module.exports = __webpack_public_path__ + "img/banner-oyster.6302adee.webp";